import React from 'react'

type ButtonProps = {
  label: string
  href?: string
  targetBlank?: boolean
  color?:
    | 'red'
    | 'white'
    | 'darkRed'
    | 'gray'
    | 'transparent'
    | 'transparentNegative'
    | 'green'
  size?: 'tiny' | 'small' | 'medium' | 'large'
  className?: string
  fn?: () => void
  iconLeft?: React.ReactNode
}

export default function Button({
  label,
  href,
  targetBlank,
  color,
  size,
  className,
  fn,
}: ButtonProps) {
  const buttonColor = color || 'red'
  const buttonSize = size || 'medium'

  const colorMap = {
    red: 'bg-red-100 text-white hover:bg-red-300',
    white: 'bg-white/100 text-red-100 hover:bg-gray-200',
    darkRed: 'bg-red-700 text-white hover:bg-red-400',
    gray: 'bg-gray-700 text-white hover:bg-gray-800',
    transparent:
      'bg-black/0 text-red-100 border-2 border-red-100 hover:bg-red-100/20',
    transparentNegative:
      'bg-white/0 text-white border-2 border-white hover:bg-white/30',
    green: 'bg-green-700 text-white hover:bg-green-800',
  }
  const sizeMap = {
    tiny: 'py-1.5 px-3 text-xs',
    small: 'py-2 px-4 text-sm',
    medium: 'py-2.5 px-4 text-lg',
    large: 'py-3 px-8 text-xl',
  }

  const target = targetBlank ? '_blank' : '_self'

  return (
    <a
      href={href}
      className={`cursor-pointer text-center w-fit rounded-lg h5 ${sizeMap[buttonSize]} transition-all ${colorMap[buttonColor]} ${className}`}
      target={target}
      onClick={fn}
    >
      <span className="slanted-content">{label}</span>
    </a>
  )
}
